import React, { FC } from "react";
import Choices from "../../Choices";
import ReusableAccordian from "../../ReusableAccordion";
import { Typography } from "@mui/material";
import { Image } from "cloudinary-react";
import { styled } from "@mui/material/styles";
import PleaseNote from "../../PleaseNote";
import LearnMore from "../../LearnMore";
import { ScreenTypeObj } from "../SliderScreen/SliderScreenAccordian";
import useScreenTypeSelector from "./useScreenTypeSelector";

const StyledImgDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  paddingTop: 40,
});

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  paddingTop: 10,
});

interface ScreenTypeProps {
  screenTypeOptions: ScreenTypeObj[];
}

const ScreenTypeAccordian: FC<ScreenTypeProps> = ({ screenTypeOptions }) => {
  const {
    brioOnlyOption,
    handleClick,
    centorImgs,
    isBrio,
    isCentor,
    screenTypeChoice,
  } = useScreenTypeSelector(screenTypeOptions.length);

  if (brioOnlyOption) return null;

  return (
    <ReusableAccordian
      accordionName="screenType"
      heading="Screen Type"
      secondaryHeading="Select a Screen Type"
      colOrRow="col"
    >
      {isCentor && (
        <Typography>
          Featuring a flat material that rolls up and provides the option for
          either screen mesh or shade.
        </Typography>
      )}

      {isBrio && (
        <Typography>
          Featuring an accordion-style material that folds up
        </Typography>
      )}

      {screenTypeChoice && (
        <LearnMore href="https://agmillworks.com/retractable-screens/" />
      )}

      <StyledDiv>
        {screenTypeOptions.map((item) => (
          <div key={item.id} onClick={() => handleClick(item.label)}>
              <Choices
                label={item.label}
                variant={
                  item.label === screenTypeChoice ? "filled" : "outlined"
                }
                checkMark={item.label === screenTypeChoice}
              />
          </div>
        ))}
      </StyledDiv>

      {isCentor && centorImgs && (
        <StyledImgDiv>
          <Image
            cloudName="ag-millworks"
            secure="true"
            publicId={centorImgs.jambLeg}
            style={{ paddingRight: 30 }}
          />
          <Image
            cloudName="ag-millworks"
            secure="true"
            publicId={centorImgs.headSill}
            style={{ paddingLeft: 30 }}
          />
        </StyledImgDiv>
      )}

      {isCentor && (
        <PleaseNote
          notes="To simplify installation, we have integrated the Centor Screen framing into our frame and added wood blocking to fill any gaps. This design requires only one rough opening through the jamb. The Net Frame Width (NFW) and Net Frame Height (NFH) measurements include the screen frame."
        />
      )}
    </ReusableAccordian>
  );
};

export default ScreenTypeAccordian;
